import React from 'react';

function AffiliatePage() {
    return <div>Affiliate Page</div>;
}

export default AffiliatePage;
